module.exports = __webpack_public_path__ + "static/img/list.d49ead55.svg";